<ion-content (touchstart)="onTouchStart($event)"
(touchmove)="onTouchMove($event)"
(touchend)="onTouchEnd($event)">
	<div class="wrapper">
		<div class="content">

			<header class="header">
				<img class="logo" src="assets/images/logo.svg" alt="Logo">
			</header>

			<div class="main">

				<div class="mr-potty">
					<img src="assets/images/add-thoughts/mr_potty_cute.svg" alt="Cute Mr Potty">

					<div class='bubble'>
						<img class="bubble__img" src="assets/images/add-thoughts/bubble.svg" alt="Bubble with text">
						<p>Whatcha thinkin' bud?</p>
					</div>

				</div>

				<div class="mr-potty-hands">
					<img class="mr-potty-invisible" src="assets/images/add-thoughts/mr_potty_cute.svg"
						alt="Cute Mr Potty">
					<img class="left-arm" src="assets/images/add-thoughts/mr_potty_cute_left_arm.svg" alt="Left Arm">
					<img class="right-arm" src="assets/images/add-thoughts/mr_potty_cute_right_arm.svg" alt="Right Arm">
				</div>

				<div class="main-content">

					<h2 class="title">Tell us your thoughts</h2>

					<app-progress-bar [activeStep]="activeStep"></app-progress-bar>

					<div class="thoughts">
						<textarea 
							class="thoughts-field" 
							[placeholder]="textAreaPlaceholder" 
							[(ngModel)]="thoughts" 
							(ngModelChange)="onThoughtsChange($event)"
							[maxlength]="maxThoughtsLength">
						</textarea>
						<span class="length-counter">{{thoughts.length}} / {{ maxThoughtsLength }}</span>
					</div>

				</div>

				<app-navigation-buttons 
					(click)="saveThoughtsMetadata($event)" 
					[isSkipButtonHidden]="true"
					[nextButtonText]="nextButtonText"
					[twoButtonsShowing]="true"
					[isSkipDisplayed]="nextButtonText === 'skip'">
				</app-navigation-buttons>

			</div>

		</div>
	</div>
</ion-content>
